import React from 'react';
import { Languages, ChevronRight, Mic } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function TranslateShortcutCard() {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate('/translate')}
      className="w-full text-left puvio-card puvio-card-interactive p-5 puvio-focus"
      data-testid="translate-shortcut-card"
    >
      <div className="flex items-center gap-4">
        <div className="w-12 h-12 rounded-2xl bg-[#15291C] flex items-center justify-center">
          <Languages className="w-6 h-6 text-[var(--puvio-sun)]" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-bold text-[11px] uppercase tracking-[0.22em] text-[var(--puvio-mint-deep)]">Translate</p>
          <p className="text-base font-extrabold text-[#0F1A13] mt-0.5 truncate">Any phrase, any language</p>
          <p className="text-[11px] text-[var(--puvio-text-2)] mt-0.5 flex items-center gap-1 font-semibold"><Mic className="w-3 h-3" /> Voice + AI in 195 languages</p>
        </div>
        <ChevronRight className="w-5 h-5 text-slate-400" />
      </div>
    </button>
  );
}
